import React from 'react';

import { LinkedinFilled, TwitterOutlined } from '@ant-design/icons';
import Image from '../../img/bottom-img.png';


export const Footer = () => {
  return (
    <div className="dl-footer">
      <div className="dl-footer__main">
        <div className="dl-footer__main-title">
          <h1>Want to learn more?</h1>
        </div>
        <div className="dl-footer__main-button">
          <button type="button">
            Contact us
          </button>
        </div>
        <div className="dl-footer__main-image">
          <img src={Image} alt="bottom" />
        </div>
      </div>
      <div className="dl-footer__bottom-bar">
        <div className="dl-footer__bottom-bar-copyrights">
          <h5>&copy; 2022 DEEPLABS | ALL RIGHTS RESERVED</h5>
        </div>
        <div className="dl-footer__bottom-bar-right">
          <div className="dl-footer__bottom-bar-right-privacy">
            <a href={process.env.REACT_APP_DEEPLABS_BASE_URL}>Privacy Policy</a>
          </div>
          <div className="dl-footer__bottom-bar-right-separator" />
          <div className="dl-footer__bottom-bar-right-icons">
            <a href="https://twitter.com">
              <TwitterOutlined />
            </a>
            <a href="https://linkedin.com">
              <LinkedinFilled />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
